import { j as t } from "../../_virtual/jsx-runtime.js";
const x = ({
  width: r = 20,
  height: o = 20,
  viewBox: s = "0 0 20 20",
  fill: n = "currentColor",
  ...e
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    width: r,
    height: o,
    viewBox: s,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M5.34517 13.2417L13.7969 4.78988L12.6184 3.61136L4.16667 12.0632V13.2417H5.34517ZM6.03553 14.9083H2.5V11.3728L12.0292 1.84359C12.3547 1.51816 12.8822 1.51816 13.2077 1.84359L15.5647 4.20062C15.8902 4.52605 15.8902 5.05369 15.5647 5.37913L6.03553 14.9083ZM2.5 16.575H17.5V18.2417H2.5V16.575Z",
        fill: n
      }
    )
  }
);
export {
  x as default
};
